import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  logs: [],
  log: null,
  logTotalItems: null,
  pagination: {
    current_page: 1,
    last_page: 0,
    rowsPerPage: 15
  }
}

// mutations
export const mutations = {
  [types.SET_LOGS] (state, payload) {
    state.logs = payload.data
    state.pagination.current_page = payload.current_page
    state.pagination.last_page = payload.last_page
    state.pagination.rowsPerPage = payload.per_page
    state.logTotalItems = payload.total
  },
  [types.SET_LOG] (state, log) {
    state.log = log
  }
}

// actions
export const actions = {
  async fetchLogs ({ commit }, payload) {
    const pageNumber = payload ? payload.page : this.state.log.pagination.current_page
    const rowsPerPage = payload ? payload.rowsPerPage : this.state.log.pagination.rowsPerPage
    try {
      const { data } = await axios.get(`/api/logs?page=${pageNumber}&size=${rowsPerPage}`, {
        params: payload ? payload.query : ''
      })
      commit(types.SET_LOGS, data)
    } catch (e) {
      console.log(e)
    }
  }
}

// getters
export const getters = {
  logs: state => state.logs,
  log: state => state.log,
  logTotalItems: state => state.logTotalItems
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/log.js